// import User from '@/fixtures/user.js'
import emma from '@/common/services/Emma'
import { resolveDate } from '@/common/services/ResolveDate'

const UserResource = {
	login (email, password) {
		return emma.post('api/login', {
			username: email,
			password: password
		})
	},
	getAdvisors (id) { return emma.get('api/client-advisors/' + id) },
	getProfile () { return emma.get('api/profile') },
	getInvestmentStats () { return emma.get('api/investment-stats') },
	logout () { return emma.get('api/logout') },
	resetPassword (email) {
		return emma.post('api/resetting/request', {
			email: email
		})
	},
	register (user) {
		return new Promise((resolve, reject) => {
			const data = new FormData()
			data.append('first_name', user.firstname)
			data.append('last_name', user.lastname)
			data.append('email', user.email)
			data.append('plain_password[first]', user.password)
			data.append('plain_password[second]', user.passwordConfirm)
			data.append('birthdate', resolveDate(user.birthdate))
			data.append('phone', user.phone)
			emma.post('api/register', data).then((result) => {
				resolve(result)
			}).catch((error) => {
				reject(error)
			})
		})
	},
	registerEnterprise (user) {
		return new Promise((resolve, reject) => {
			const data = new FormData()
			data.append('email', user.email)
			data.append('plain_password[first]', user.password)
			data.append('plain_password[second]', user.password)
			data.append('company_name', user.name)
			data.append('company_siret', user.siret)
			data.append('phone', user.phone)
			emma.post('api/register', data).then((result) => {
				resolve(result)
			}).catch((error) => {
				reject(error)
			})
		})
	},
	updateProfilePicture (data, id) {
		const request = new FormData()
		request.append('img', data)
		return emma.post('api/media/user_picture/' + id, request, 'application/x-www-form-urlencoded')
	},
	updateProfile (data) {
		const request = new FormData()
		request.append('first_name', data.firstname)
		request.append('last_name', data.lastname)
		request.append('email', data.email)
		request.append('address', data.address.line)
		request.append('zipcode', data.address.zip)
		request.append('city', data.address.city)
		request.append('country', data.address.country)
		request.append('phone', data.phone)
		request.append('birthdate', resolveDate(data.birthdate))
		return emma.post('api/profile', request)
	},
	editPassword (data) {
		return emma.post('api/change-password', data)
	},
	updateTutorialFinished (isFinished) {
		return emma.post('api/user/tutorial-finished', {
			isFinished: isFinished
		})
	}
}

export default UserResource



// WEBPACK FOOTER //
// ./src/resources/User.js